import { NavigationPathsEnum } from "@utilities/enums";
import { useNavigation, useOrganisation, useUser } from "@utilities/hooks";
import { useCallback, useMemo, useState } from "react";

enum TabLabelsEnum {
    GENERAL = "Général",
    MY_SPACE = "Mon espace",
    MY_ORGANISATION = "Mon entreprise",
    COLLABORATORS = "Collaborateurs",
    PLANNING = "Planning",
    SUBSCRIPTION = "Abonnement"
}

export const useControllers = () => {

    const { isOrganisationInfosIsComplete, isUserAdmin } = useOrganisation();
    const { isUserInfosIsComplete } = useUser();
    const { navigateTo } = useNavigation();

    const [_, setIsDrawerOpen] = useState<boolean>(false);

    const isDisabledTab = useMemo(() => (
        !isUserInfosIsComplete || !isOrganisationInfosIsComplete
    ),[ isUserInfosIsComplete, isOrganisationInfosIsComplete ]);

    const tabs = useMemo(() => [
        { label: TabLabelsEnum.GENERAL, link: NavigationPathsEnum.SETTINGS, disabled: isDisabledTab, isHide: false },
        { label: TabLabelsEnum.MY_SPACE, link: NavigationPathsEnum.SETTINGS_MY_ACCOUNT, disabled: false, isHide: false },
        { label: TabLabelsEnum.MY_ORGANISATION, link: NavigationPathsEnum.SETTINGS_MY_ORGANISATION, disabled: false, isHide: false },
        { label: TabLabelsEnum.COLLABORATORS, link: NavigationPathsEnum.SETTINGS_COLLABORATORS, disabled: isDisabledTab, isHide: !isUserAdmin },
        { label: TabLabelsEnum.PLANNING, link: NavigationPathsEnum.SETTINGS_PLANNING, disabled: isDisabledTab, isHide: !isUserAdmin },
        { label: TabLabelsEnum.SUBSCRIPTION, link: NavigationPathsEnum.SETTINGS_SUBSCRIPTION, disabled: isDisabledTab, isHide: !isUserAdmin },
    ], [isDisabledTab, isUserAdmin]);

    const onToggleDrawer = useCallback(() => setIsDrawerOpen(prev => !prev), []);

    const handleTabClick = useCallback((tab: any) => {
        if (!tab.disabled) {
            navigateTo(tab.link);
        }
    }, [navigateTo]);

    return {
        tabs,
        onToggleDrawer, handleTabClick,
    }
}
